import React from 'react';
import { Colors } from '@/common/colors/colors';
import PopUp from '@/common/components/PopUp';
import ActionButton from '@/common/components/buttons/ActionButton';
import { ButtonsWrapper, Title } from './Warning.styled';

const Warning = ({ setShowWarning, handleSubmit }) => {
	return (
		<PopUp padding='10px 20px 14px' setShow={setShowWarning}>
			<Title>
				After accepting, it will be impossible to change invoice! Are you sure
				that you want to accept it?
			</Title>
			<ButtonsWrapper>
				<ActionButton
					onClick={() => setShowWarning(() => false)}
					color={Colors.red}
					defaultText='No'
				/>
				<ActionButton
					onClick={() => handleSubmit()}
					color={Colors.green}
					defaultText='Yes'
				/>
			</ButtonsWrapper>
		</PopUp>
	);
};

export default Warning;
